module.exports = __webpack_public_path__ + "img/v7.de4d7188.png";